import { BillingPlanId } from '@/modules/billing/constants/BillingPlanId';
import { SelfServeBillingPlanForm } from '@/modules/estate/models/SelfServeBillingPlanForm';
import { SolutionsBillingPlanForm } from '@/modules/estate/models/SolutionsBillingPlanForm';

export class VaultBillingPlanFormFactory {
  static build(
    billingPlanId: string,
    price?: number,
    yearlyPrice?: number,
    isROC?: boolean,
    isSaasBilling?: boolean
  ): SelfServeBillingPlanForm | undefined {
    switch (billingPlanId) {
      case BillingPlanId.INDIVIDUAL_STANDARD_PLAN:
        return new SelfServeBillingPlanForm({ billingPlanId, isSaasBilling })
          .setAsStandardPlan(false, isROC)
          .setPrices(price, yearlyPrice);
      case BillingPlanId.INDIVIDUAL_BASIC_PLAN:
        return new SelfServeBillingPlanForm({ billingPlanId, isSaasBilling })
          .setAsBasicPlan(false, isROC)
          .setPrices(price, yearlyPrice);
      case BillingPlanId.COUPLES_BASIC_PLAN:
        return new SelfServeBillingPlanForm({ billingPlanId, isSaasBilling })
          .setAsBasicPlan(false, isROC)
          .setAsCouples()
          .setPrices(price, yearlyPrice);
      case BillingPlanId.INDIVIDUAL_COMPLETE_PLAN:
        return new SelfServeBillingPlanForm({ billingPlanId, isSaasBilling })
          .setAsCompletePlan()
          .setPrices(price, yearlyPrice);
      case BillingPlanId.COUPLES_COMPLETE_PLAN:
        return new SelfServeBillingPlanForm({ billingPlanId, isSaasBilling })
          .setAsCompletePlan()
          .setAsCouples()
          .setPrices(price, yearlyPrice);
      case BillingPlanId.INDIVIDUAL_PROFESSIONAL_EXECUTOR:
        return new SelfServeBillingPlanForm({ billingPlanId, isSaasBilling })
          .setAsProfessionalPlan()
          .setPrices(price, yearlyPrice);
      case BillingPlanId.COUPLES_PROFESSIONAL_EXECUTOR:
        return new SelfServeBillingPlanForm({ billingPlanId, isSaasBilling })
          .setAsProfessionalPlan()
          .setAsCouples()
          .setPrices(price, yearlyPrice);
      case BillingPlanId.INDIVIDUAL_DIGITAL_VAULT:
        return new SolutionsBillingPlanForm({ billingPlanId, isSaasBilling }).setAsDigitalVault(
          false,
          false
        );
      case BillingPlanId.INDIVIDUAL_CUSTOM:
        return new SelfServeBillingPlanForm({ billingPlanId, isSaasBilling }).setAsCustomPlan();
      default:
        return undefined;
    }
  }
}
